import React from 'react';

import { Avatar, Box, Chip, Text, useTheme } from '@ublend-npm/aulaui-core';

import useBreakpoints from '@app/hooks/useBreakpoints';
import { DARK } from '@core/constants/theme';

import { DARK_THEME_RED_TEXT, LIGHT_THEME_RED_TEXT } from './types';

type ParticipantHistoryAccordionItemProps = {
  avatar?: string;
  isEducator: boolean;
  firstName: string;
  lastName: string;
  eventType: string;
};

const ParticipantHistoryAccordionItem = ({
  avatar,
  isEducator,
  firstName,
  lastName,
  eventType,
}: ParticipantHistoryAccordionItemProps) => {
  const { palette } = useTheme();
  const isDarkTheme = palette?.mode === DARK;

  const { md } = useBreakpoints();

  const initials = `${firstName?.substring(0, 1)?.toUpperCase() || ''}${
    lastName?.substring(0, 1)?.toUpperCase() || ''
  }`;

  const textSx =
    eventType === 'removed'
      ? {
          color: isDarkTheme ? DARK_THEME_RED_TEXT : LIGHT_THEME_RED_TEXT,
        }
      : {};

  return (
    <Box
      sx={{
        py: 1,
        px: 2.5,
        my: 1,
        backgroundColor: md
          ? palette.background.default
          : palette.background.paper,
        borderRadius: 1,
        display: 'flex',
        gap: 1.5,
        alignItems: 'center',
      }}
    >
      <Avatar
        src={avatar}
        fallbackText={initials}
        sx={{ width: 32, height: 32 }}
      />
      <Text>
        <span style={textSx}>
          {firstName} {lastName}
        </span>
        {isEducator ? (
          <Box sx={{ display: 'inline-block', mx: 1 }}>
            <Chip
              sx={{
                backgroundColor: palette.secondary.main,
                cursor: 'default',
              }}
              kind="primary"
              size="small"
              label="Educator"
            />
          </Box>
        ) : null}
      </Text>
    </Box>
  );
};

export default ParticipantHistoryAccordionItem;
